
export default function BoltWhiteLabel({data}) {
  return (
    <>
      <section className="bolt-white-label-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <h3 className="heading center-heading"> {data && data.title}</h3>
              <p className="sub-heading">{data && data.description}</p>
            </div>

            {data && data.boxes && data.boxes.map((box, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div className="bolt-white-label-box">
                  <img src={box.image} alt="smart" className="img-responsive" loading="lazy"/>
                  <span>{box.title}</span>
                  <p>{box.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
